import React, { useState } from "react";
import { AppIcons } from "../../../data/appIcons";
import Image from "../../image/Image";
import "./pagination.scss";

const MolPagination = ({
  pageSize,
  currentPage,
  totalPages,
  onPageChange,
  onPageSizeChange,
}) => {

  const [inputPage, setInputPage] = useState(currentPage);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
      setInputPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
      setInputPage(currentPage + 1);
    }
  };

  const handleGoToPage = () => {
    const pageNumber = parseInt(inputPage, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      onPageChange(pageNumber);
    }
  };

  const handlePageInputChange = (event) => {
    const input = event.target.value;
    setInputPage(input);
  };


  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    onPageSizeChange(newSize);
    setInputPage(1);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleGoToPage();
    }
  };

  const handleDirectLastPage = () => {
    if (totalPages) {
      onPageChange(totalPages);
    }
  }

  const handleDirectFirstPage = () => {
    if (totalPages) {
      onPageChange(1);
    }
  }

  const renderPageNumbers = () => {
    const pageNumbers = [];

    // Calculate the start and end page numbers to display
    let startPage = Math.max(currentPage - 2, 1);
    let endPage = Math.min(startPage + 4, totalPages);

    // Adjust the startPage if there are fewer than 5 pages to display
    if (endPage - startPage < 4) {
      startPage = Math.max(endPage - 4, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          className={i === currentPage ? "active-button" : ""}
          onClick={() => {
            onPageChange(i);
            setInputPage(i); // Update inputPage when a page number is clicked
          }}
        >
          {i}
        </button>
      );
    }

    return pageNumbers;
  };

  const generatePageSizeOptions = () => {
    const options = [];

    // Add static page sizes
    const staticPageSizes = [10, 20, 50, 100];

    // Ensure the dynamicPageSize is not in the staticPageSizes array
    const dynamicPageSize = pageSize; // Replace with the dynamic page size from props

    // Check if dynamicPageSize is already in staticPageSizes
    const isDynamicPageSizeInStatic = staticPageSizes.includes(dynamicPageSize);

    // Combine static and dynamic page sizes (excluding dynamicPageSize if it's in staticPageSizes)
    const allPageSizes = isDynamicPageSizeInStatic
      ? [...staticPageSizes]
      : [...staticPageSizes, dynamicPageSize];

    // Sort allPageSizes in ascending order
    allPageSizes.sort((a, b) => a - b);

    for (const size of allPageSizes) {
      options.push(
        <option key={"sel_" + size} value={size}>
          {size}
        </option>
      );
    }

    return options;
  };

  return (
    <>
      <div className="table-pagination">
        <p>
          Page
          <input
            // type="number"
            className="new-input-page ml-1"
            value={inputPage}
            onChange={handlePageInputChange}
            onBlur={handleGoToPage}
            onKeyPress={handleKeyPress}
            min="1"
            max={totalPages}
          />
          <span className="ml-2"> of</span>
          <span className="ml-2">{totalPages}</span>
        </p>
        <div className="display-per-page">
          Page Size:
          <select value={pageSize} onChange={handlePageSizeChange}>
            {generatePageSizeOptions()}
          </select>
        </div>
        <div className="gap-2 pagination">
          <button title="First" onClick={handleDirectFirstPage}>
            <Image
              imgCustomClassName="left-arrow last-left"
              imagePath={AppIcons.EndArrowIcon}
              altText="Prev Icon"
            />
          </button>
          <button title="Previous" onClick={handlePrevious}>
            <Image
              imgCustomClassName="left-arrow"
              imagePath={AppIcons.arrowIcon}
              altText="Arrow Icon"
            />
          </button>
          {renderPageNumbers()}
          <button title="Next" onClick={handleNext}>
            <Image
              imgCustomClassName="right-arrow"
              imagePath={AppIcons.arrowIcon}
              altText="Arrow Icon"
            />
          </button>
          <button title="Last" onClick={handleDirectLastPage}>
            <Image
              imgCustomClassName="right-arrow last-right"
              imagePath={AppIcons.EndArrowIcon}
              altText="Next Icon"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default MolPagination;
